import { Controller } from "stimulus";

// Toggles the course/activity ranking between the "Mensal" (seasonal) and "LTV" (total
// lifetime) views, and scrolls to the churn section when the churn KPI card is clicked.
// Both ranking panels are rendered server-side; this controller only swaps visibility so
// all currency/I18n formatting stays on the server.
export default class extends Controller {
  static targets = ["modeButton", "panel", "churn"];

  toggle(event) {
    const button = event.currentTarget;
    const mode = button.dataset.mode;
    // Scope to the clicked section so independent toggles (ranking vs experimentals) don't clash.
    const section = button.closest("section");
    if (!section) return;

    section.querySelectorAll('[data-course-performance-target="modeButton"]').forEach((modeButton) => {
      const active = modeButton.dataset.mode === mode;
      modeButton.classList.toggle("bg-white", active);
      modeButton.classList.toggle("shadow-sm", active);
      modeButton.classList.toggle("text-gray-900", active);
      modeButton.classList.toggle("text-gray-500", !active);
    });

    section.querySelectorAll('[data-course-performance-target="panel"]').forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.mode !== mode);
    });
  }

  scrollToChurn(event) {
    event.preventDefault();
    if (!this.hasChurnTarget) return;

    this.churnTarget.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
